import { NgModule } from '@angular/core';
import { AssociateSearchModalComponent } from './associate-search-modal/associate-search-modal.component';
import { AssociateSearchTriggerComponent } from './associate-search-trigger/associate-search-trigger.component';

/**
 * Thin re-export shell that exposes the standalone AssociateSearch components to
 * unmigrated NgModule-based consumers. Today this is DotcomFooterModule, which
 * pulls in AssociateSearchModalComponent (opened via NgbModal from the footer)
 * and AssociateSearchTriggerComponent so they're available in the root injector.
 *
 * The /associate-search route loads its own routes file (associate-search.routes.ts)
 * and does NOT import this module, which preserves the previous behavior of keeping
 * the trigger route out of the root injector.
 *
 * New code should import AssociateSearchModalComponent / AssociateSearchTriggerComponent
 * directly rather than going through this module.
 */
@NgModule({
    imports: [AssociateSearchModalComponent, AssociateSearchTriggerComponent],
    exports: [AssociateSearchModalComponent, AssociateSearchTriggerComponent],
})
export class AssociateSearchModule {}
